(function (lib, img, cjs, ss, an) {

var p; // shortcut to reference prototypes
lib.ssMetadata = [];


// symbols:



(lib.TransitionBubble = function() {
	this.initialize(img.TransitionBubble);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,456,481);


(lib.TransitionBubblePop = function() {
	this.initialize(img.TransitionBubblePop);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,456,481);// helper functions:

function mc_symbol_clone() {
	var clone = this._cloneProps(new this.constructor(this.mode, this.startPosition, this.loop));
	clone.gotoAndStop(this.currentFrame);
	clone.paused = this.paused;
	clone.framerate = this.framerate;
	return clone;
}

function getMCSymbolPrototype(symbol, nominalBounds, frameBounds) {
	var prototype = cjs.extend(symbol, cjs.MovieClip);
	prototype.clone = mc_symbol_clone;
	prototype.nominalBounds = nominalBounds;
	prototype.frameBounds = frameBounds;
	return prototype;
	}


(lib.M_Wash_Bubblebubblewipe = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Bitmap
	this.instance = new lib.TransitionBubble();
	this.instance.parent = this;
	this.instance.setTransform(-7,-8,0.076,0.076);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.M_Wash_Bubblebubblewipe, new cjs.Rectangle(-7,-8,34.6,36.5), null);


(lib.M_Wash_Bubble_popbubblewipe = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Bitmap
	this.instance = new lib.TransitionBubblePop();
	this.instance.parent = this;
	this.instance.setTransform(27.6,17.1,0.052,0.052,154.1);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.M_Wash_Bubble_popbubblewipe, new cjs.Rectangle(-4.6,-5.3,32.2,32.7), null);


(lib.LoadText = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Over
	this.shape = new cjs.Shape();
	this.shape.graphics.f("#3B9C9B").s().p("AZqFeQgjgHgegNQgegNgagTQgZgTgWgYQgUgYgRgcQgRgcgLghQgLgggGgjQgFgkgBgmQABgmAFglQAHgkALghQANghAQgcQASgcAWgYQAVgYAbgSQAbgTAegNQAggNAigGQAigHAmAAQA7AAA2AOQA1APAjAZQAZARANAVQAOAVAAAXQAAAbgSASQgSATgaAAQgYAAgmgcQhIgpg4AAQgrAAgiAQQgiARgXAeQgYAegMApQgNAqAAAwQAAAwAMApQALAqAYAeQAXAgAhARQAjASArAAQAhAAAcgLQAbgLAUgUQAUgUAKgdQAMgcABgjIhaAAQglAAgUgTQgRgRAAgdQAAgcARgSQAUgSAlAAICXAAQAuAAAWAWQAVAWAAAwQAAAigGAhQgFAhgKAdQgMAdgPAaQgQAagTAVQgVAVgYARQgZARgcALQgcAMghAGQggAGgjAAQgmAAghgHgA1UFeQgigGgegNQgegNgbgSQgZgTgWgXQgVgYgQgdQgRgcgMggQgLghgGgkQgGglAAgnQAAgoAGgkQAGglALghQAMggARgcQAQgdAWgXQAWgXAZgSQAagTAfgMQAegNAhgGQAjgHAlAAQAkAAAiAHQAhAGAfANQAeAMAaATQAaASAVAXQAWAXARAdQARAcALAgQAMAhAFAlQAHAkgBAoQABAngHAlQgFAkgMAhQgLAggRAcQgRAdgVAYQgWAXgZATQgbASgdANQgfANghAGQgjAHgkAAQgmAAgigHgA1bjSQggARgYAgQgXAegMArQgLApAAAwQAAAwALAqQANApAWAfQAYAfAgARQAjARAsAAQAqAAAjgRQAhgRAYggQAXgeALgqQAMgpAAgwQAAgwgMgpQgLgrgXgeQgXgggigRQgigSgrAAQgsAAgjASgASqFOQgQgOgfgoIkXl1IgCAAIAAFuQgBAkgSAVQgTAVghAAQgiAAgSgVQgUgVABgkIAAojQgBgnATgTQARgSAhAAQAaAAAVAQQAQAOAeAnIEXF4IADAAIAAlvQAAgkASgVQAUgVAhAAQAhAAATAVQATAVAAAkIAAIdQAAApgSAVQgQAUgjAAQgYAAgWgRgAnDFHQgMgOgHgUIgchXIkKAAIgdBXQgWA6gvAAQgfAAgTgSQgSgRAAgcQAAgXAQgrIC6n1QAMghASgRQAMgNAPgHQATgHAWAAQAXAAASAHQAQAHAMANQARARAMAhIC6H1QAOArAAAXQAAAcgSARQgSASgfAAQgfAAgVgYgAodBMIhWkQIgCAAIheEQIC2AAgAGdFYQgkAAgTgSQgRgQAAgdQAAgcARgQQATgSAkAAIAPAAIAAm1IgPAAQgkAAgTgSQgRgQAAgcQAAgdARgQQATgRAkAAICqAAQAlAAASARQARAQAAAdQAAAcgRAQQgSASglAAIgPAAIAAG1IAPAAQAlAAASASQARAQAAAcQAAAdgRAQQgSASglAAgAi4FYQgsAAgUgTQgVgUAAgpIAAoPQAAgpAVgUQAUgSAsAAICdAAQAmAAAiAGQAjAHAfANQAdANAbASQAZATAWAWQAUAXAQAcQAQAaALAfQAMAeAEAhQAGAhAAAkQAAAngGAlQgGAkgMAhQgLAggRAcQgRAbgWAXQgWAWgZASQgaARgdAMQgdAMggAGQghAGghAAgAh/DVIBYAAQAuAAAlgPQAkgPAYgdQAXgdANgoQAMgpgBgzQABgvgMglQgNgngXgaQgZgcgjgOQglgOgtAAIhZAAgA+SFYQgrAAgUgTQgUgTAAgqIAAoYQAAgkATgVQATgVAhAAQAhAAATAVQATAVAAAkIAAHlICoAAQAlAAATATQASASAAAdQAAAdgSARQgTATglAAg");
	this.shape.setTransform(-37,-11.4);

	this.shape_1 = new cjs.Shape();
	this.shape_1.graphics.f("#3B9C9B").s().p("AfYFOQgXgWAAggQAAgiAXgXQAXgWAhAAQAhAAAWAWQAXAXAAAiQAAAggXAWQgWAXghAAQghAAgXgXgAXyFeQgigHgfgNQgdgNgagTQgagTgVgYQgVgYgRgcQgQgcgLghQgMgggFgjQgGgkAAgmQAAgmAGglQAGgkAMghQAMghARgcQARgcAWgYQAWgYAbgSQAagTAfgNQAfgNAigGQAjgHAlAAQA8AAA1AOQA1APAjAZQAZARAOAVQANAVAAAXQAAAbgSASQgSATgaAAQgYAAglgcQhJgpg4AAQgqAAgjAQQghARgYAeQgYAegMApQgNAqAAAwQAAAwAMApQAMAqAXAeQAXAgAhARQAjASArAAQAhAAAcgLQAbgLAUgUQAUgUALgdQALgcACgjIhbAAQglAAgTgTQgSgRAAgdQAAgcASgSQATgSAlAAICXAAQAuAAAWAWQAVAWAAAwQAAAigFAhQgGAhgKAdQgLAdgQAaQgPAagUAVQgVAVgYARQgZARgcALQgcAMggAGQghAGgjAAQglAAgigHgA3MFeQgigGgegNQgegNgagSQgagTgVgXQgWgYgQgdQgRgcgMggQgLghgGgkQgGglAAgnQAAgoAGgkQAGglALghQAMggARgcQAQgdAWgXQAWgXAagSQAagTAegMQAegNAhgGQAjgHAlAAQAkAAAiAHQAiAGAeANQAeAMAaATQAaASAWAXQAVAXARAdQARAcALAgQAMAhAGAlQAGAkAAAoQAAAngGAlQgGAkgMAhQgLAggRAcQgQAdgWAYQgVAXgaATQgaASgeANQgfANghAGQgjAHgkAAQglAAgjgHgA3TjSQggARgYAgQgXAegMArQgLApAAAwQAAAwALAqQANApAWAfQAYAfAgARQAkARArAAQArAAAigRQAigRAXggQAXgeALgqQAMgpAAgwQAAgwgMgpQgLgrgXgeQgXggghgRQgjgSgrAAQgsAAgjASgAQzFOQgRgOgfgoIkXl1IgCAAIAAFuQAAAkgTAVQgTAVghAAQghAAgTgVQgTgVAAgkIAAojQAAgnASgTQARgSAiAAQAZAAAVAQQARAOAdAnIEXF4IADAAIAAlvQAAgkATgVQATgVAhAAQAhAAATAVQATAVAAAkIAAIdQAAApgSAVQgQAUgiAAQgZAAgVgRgAo6FHQgMgOgIgUIgchXIkKAAIgdBXQgWA6gvAAQgfAAgTgSQgRgRAAgcQAAgXAPgrIC7n1QALghASgRQAMgNAPgHQATgHAWAAQAXAAASAHQAQAHAMANQARARAMAhIC6H1QAPArAAAXQAAAcgTARQgSASgfAAQgfAAgUgYgAqUBMIhXkQIgCAAIheEQIC3AAgAElFYQgkAAgSgSQgRgQAAgdQAAgcARgQQASgSAkAAIAPAAIAAm1IgPAAQgkAAgSgSQgRgQAAgcQAAgdARgQQASgRAkAAICrAAQAkAAASARQASAQAAAdQAAAcgSAQQgSASgkAAIgQAAIAAG1IAQAAQAkAAASASQASAQAAAcQAAAdgSAQQgSASgkAAgAkwFYQgrAAgVgTQgVgUAAgpIAAoPQAAgpAVgUQAVgSArAAICdAAQAnAAAjAGQAiAHAfANQAdANAaASQAZATAWAWQAVAXAQAcQAQAaAKAfQAMAeAFAhQAFAhAAAkQAAAngGAlQgGAkgMAhQgLAggRAcQgRAbgWAXQgVAWgZASQgaARgcAMQgeAMggAGQghAGgiAAgAj3DVIBYAAQAvAAAlgPQAkgPAYgdQAXgdAMgoQAMgpAAgzQAAgvgMglQgNgngWgaQgYgcgkgOQgkgOgvAAIhZAAgEggJAFYQgsAAgUgTQgUgTAAgqIAAoYQAAgkATgVQATgVAhAAQAhAAATAVQATAVAAAkIAAHlICoAAQAlAAATATQASASAAAdQAAAdgSARQgTATglAAg");
	this.shape_1.setTransform(-25,-11.4);

	this.shape_2 = new cjs.Shape();
	this.shape_2.graphics.f("#3B9C9B").s().p("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");
	this.shape_2.setTransform(-11.4,-11.4);

	this.shape_3 = new cjs.Shape();
	this.shape_3.graphics.f("#3B9C9B").s().p("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");
	this.shape_3.setTransform(2.1,-11.4);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.shape}]}).to({state:[{t:this.shape_1}]},2).to({state:[{t:this.shape_2}]},2).to({state:[{t:this.shape_3}]},2).wait(2));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-244.2,-47.1,409.4,76.5);


(lib.bubblewipebubble = function(mode,startPosition,loop) {
if (loop == null) { loop = false; }	this.initialize(mode,startPosition,loop,{});

	// timeline functions:
	this.frame_30 = function() {
		/* stop();*/
	}

	// actions tween:
	this.timeline.addTween(cjs.Tween.get(this).wait(30).call(this.frame_30).wait(1));

	// M_Wash_Bubble
	this.instance = new lib.M_Wash_Bubblebubblewipe();
	this.instance.parent = this;
	this.instance.setTransform(0.3,-0.2,0.078,0.078,-155.3,0,0,11.2,10.5);

	this.instance_1 = new lib.M_Wash_Bubble_popbubblewipe();
	this.instance_1.parent = this;
	this.instance_1.setTransform(0.2,-0.1,1.141,1.141,-155.3,0,0,11,10.9);
	this.instance_1._off = true;

	this.timeline.addTween(cjs.Tween.get(this.instance).to({regY:10.3,scaleX:0.91,scaleY:0.91,rotation:-155.4,x:0.2,y:0},9,cjs.Ease.get(1)).wait(1).to({regX:10.3,scaleX:0.88,scaleY:0.88,x:0.9,y:0.3},0).wait(1).to({scaleX:0.82,scaleY:0.82,y:0.2},0).wait(1).to({scaleX:0.78,scaleY:0.78,rotation:-155.3,y:0.1},0).wait(1).to({regX:11,regY:11,scaleX:0.76,scaleY:0.76,x:0.3,y:-0.2},0).to({_off:true},10).wait(8));
	this.timeline.addTween(cjs.Tween.get(this.instance_1).wait(23).to({_off:false},0).to({regX:10.9,scaleX:1.93,scaleY:1.93,x:0.3,y:0,alpha:0},4).to({_off:true},1).wait(3));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-24.2,-24.5,53,53);


// stage content:
(lib.Transition = function(mode,startPosition,loop) {
if (loop == null) { loop = false; }	this.initialize(mode,startPosition,loop,{hidden:0,onTransitionOut:1,onTransitionOut_stop:19,onTransitionIn:20,onTransitionIn_stop:47,bubbles:1,bubbles_stop:47});

	// Text
	this.instance = new lib.LoadText();
	this.instance.parent = this;
	this.instance.setTransform(659.7,401.5,1.403,1.403,0,0,0,-39.5,-9.1);
	this.instance._off = true;

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(9).to({_off:false},0).to({_off:true},21).wait(177));

	// Layer 3
	this.instance_1 = new lib.bubblewipebubble("synched",0,false);
	this.instance_1.parent = this;
	this.instance_1.setTransform(1265.3,744.8,24.681,22.733,0,0,0,0.1,0.1);

	this.instance_2 = new lib.bubblewipebubble("synched",0,false);
	this.instance_2.parent = this;
	this.instance_2.setTransform(864.4,-31.2,24.681,22.733,0,0,0,0.1,0.1);

	this.instance_3 = new lib.bubblewipebubble("synched",0,false);
	this.instance_3.parent = this;
	this.instance_3.setTransform(565.1,-86.3,24.681,22.733,0,0,0,0.1,0.1);

	this.instance_4 = new lib.bubblewipebubble("synched",0,false);
	this.instance_4.parent = this;
	this.instance_4.setTransform(318.6,-75.3,24.681,22.733,0,0,0,0.1,0.1);

	this.instance_5 = new lib.bubblewipebubble("synched",0,false);
	this.instance_5.parent = this;
	this.instance_5.setTransform(613.5,848.9,24.681,22.733,0,0,0,0.1,0.1);

	this.instance_6 = new lib.bubblewipebubble("synched",0,false);
	this.instance_6.parent = this;
	this.instance_6.setTransform(348.9,822.7,24.681,22.733,0,0,0,0.1,0.1);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[]}).to({state:[{t:this.instance_6},{t:this.instance_5},{t:this.instance_4},{t:this.instance_3},{t:this.instance_2},{t:this.instance_1}]},12).to({state:[]},35).wait(160));

	// bubble
	this.instance_7 = new lib.bubblewipebubble("synched",0,false);
	this.instance_7.parent = this;
	this.instance_7.setTransform(1331.9,428,5.337,5.337,108.1);

	this.instance_8 = new lib.bubblewipebubble("synched",0,false);
	this.instance_8.parent = this;
	this.instance_8.setTransform(1367.3,532.6,7.446,7.446,108.1);

	this.instance_9 = new lib.bubblewipebubble("synched",0,false);
	this.instance_9.parent = this;
	this.instance_9.setTransform(1336,710.3,15.23,15.23,108.1);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[]}).to({state:[{t:this.instance_9},{t:this.instance_8},{t:this.instance_7}]},18).to({state:[]},29).wait(160));

	// bubble
	this.instance_10 = new lib.bubblewipebubble("synched",0,false);
	this.instance_10.parent = this;
	this.instance_10.setTransform(1206.3,762.4,15.397,15.397);

	this.instance_11 = new lib.bubblewipebubble("synched",0,false);
	this.instance_11.parent = this;
	this.instance_11.setTransform(1216.3,583.6,15.397,15.397);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[]}).to({state:[{t:this.instance_11},{t:this.instance_10}]},18).to({state:[]},29).wait(160));

	// bubble
	this.instance_12 = new lib.bubblewipebubble("synched",0,false);
	this.instance_12.parent = this;
	this.instance_12.setTransform(1212.4,374.9,13.282,13.282);
	this.instance_12._off = true;

	this.timeline.addTween(cjs.Tween.get(this.instance_12).wait(13).to({_off:false},0).to({_off:true},34).wait(160));

	// bubble
	this.instance_13 = new lib.bubblewipebubble("synched",0,false);
	this.instance_13.parent = this;
	this.instance_13.setTransform(889.7,723.6,9.445,9.445);

	this.instance_14 = new lib.bubblewipebubble("synched",0,false);
	this.instance_14.parent = this;
	this.instance_14.setTransform(1033.7,660.5,13.282,13.282);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[]}).to({state:[{t:this.instance_14},{t:this.instance_13}]},12).to({state:[]},35).wait(160));

	// bubble
	this.instance_15 = new lib.bubblewipebubble("synched",0,false);
	this.instance_15.parent = this;
	this.instance_15.setTransform(941.7,543.8,7.273,7.273);

	this.instance_16 = new lib.bubblewipebubble("synched",0,false);
	this.instance_16.parent = this;
	this.instance_16.setTransform(864.3,591.6,11.688,11.688);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[]}).to({state:[{t:this.instance_16},{t:this.instance_15}]},15).to({state:[]},32).wait(160));

	// bubble
	this.instance_17 = new lib.bubblewipebubble("synched",0,false);
	this.instance_17.parent = this;
	this.instance_17.setTransform(1055.6,473.2,13.282,13.282);
	this.instance_17._off = true;

	this.timeline.addTween(cjs.Tween.get(this.instance_17).wait(11).to({_off:false},0).to({_off:true},36).wait(160));

	// bubble
	this.instance_18 = new lib.bubblewipebubble("synched",0,false);
	this.instance_18.parent = this;
	this.instance_18.setTransform(1254.2,199.2,10.094,10.094);

	this.instance_19 = new lib.bubblewipebubble("synched",0,false);
	this.instance_19.parent = this;
	this.instance_19.setTransform(1155.9,73.5,13.282,13.282);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[]}).to({state:[{t:this.instance_19},{t:this.instance_18}]},11).to({state:[]},36).wait(160));

	// bubble
	this.instance_20 = new lib.bubblewipebubble("synched",0,false);
	this.instance_20.parent = this;
	this.instance_20.setTransform(1072.9,240,15.702,15.702);
	this.instance_20._off = true;

	this.timeline.addTween(cjs.Tween.get(this.instance_20).wait(10).to({_off:false},0).to({_off:true},37).wait(160));

	// bubble
	this.instance_21 = new lib.bubblewipebubble("synched",0,false);
	this.instance_21.parent = this;
	this.instance_21.setTransform(910.2,374.9,15.938,15.938);
	this.instance_21._off = true;

	this.timeline.addTween(cjs.Tween.get(this.instance_21).wait(13).to({_off:false},0).to({_off:true},34).wait(160));

	// bubble
	this.instance_22 = new lib.bubblewipebubble("synched",0,false);
	this.instance_22.parent = this;
	this.instance_22.setTransform(459.2,735.8,5.337,5.337);

	this.instance_23 = new lib.bubblewipebubble("synched",0,false);
	this.instance_23.parent = this;
	this.instance_23.setTransform(523.6,723.9,7.446,7.446);

	this.instance_24 = new lib.bubblewipebubble("synched",0,false);
	this.instance_24.parent = this;
	this.instance_24.setTransform(702.3,698.5,15.23,15.23);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[]}).to({state:[{t:this.instance_24},{t:this.instance_23},{t:this.instance_22}]},9).to({state:[]},38).wait(160));

	// bubble
	this.instance_25 = new lib.bubblewipebubble("synched",0,false);
	this.instance_25.parent = this;
	this.instance_25.setTransform(970.8,69.7,10.572,10.572);

	this.instance_26 = new lib.bubblewipebubble("synched",0,false);
	this.instance_26.parent = this;
	this.instance_26.setTransform(924.4,196.3,8.81,8.81);

	this.instance_27 = new lib.bubblewipebubble("synched",0,false);
	this.instance_27.parent = this;
	this.instance_27.setTransform(839,114.2,9.351,9.351);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[]}).to({state:[{t:this.instance_27},{t:this.instance_26},{t:this.instance_25}]},9).to({state:[]},38).wait(160));

	// bubble
	this.instance_28 = new lib.bubblewipebubble("synched",0,false);
	this.instance_28.parent = this;
	this.instance_28.setTransform(762.1,492.7,13.282,13.282);
	this.instance_28._off = true;

	this.timeline.addTween(cjs.Tween.get(this.instance_28).wait(8).to({_off:false},0).to({_off:true},39).wait(160));

	// bubble
	this.instance_29 = new lib.bubblewipebubble("synched",0,false);
	this.instance_29.parent = this;
	this.instance_29.setTransform(569.6,594.9,13.282,13.282);
	this.instance_29._off = true;

	this.timeline.addTween(cjs.Tween.get(this.instance_29).wait(11).to({_off:false},0).to({_off:true},36).wait(160));

	// bubble
	this.instance_30 = new lib.bubblewipebubble("synched",0,false);
	this.instance_30.parent = this;
	this.instance_30.setTransform(762.1,270.4,14.285,14.285);
	this.instance_30._off = true;

	this.timeline.addTween(cjs.Tween.get(this.instance_30).wait(7).to({_off:false},0).to({_off:true},40).wait(160));

	// bubble
	this.instance_31 = new lib.bubblewipebubble("synched",0,false);
	this.instance_31.parent = this;
	this.instance_31.setTransform(666.9,98.4,18.373,18.373);
	this.instance_31._off = true;

	this.timeline.addTween(cjs.Tween.get(this.instance_31).wait(7).to({_off:false},0).to({_off:true},40).wait(160));

	// bubble
	this.instance_32 = new lib.bubblewipebubble("synched",0,false);
	this.instance_32.parent = this;
	this.instance_32.setTransform(591.7,391,18.899,18.899);
	this.instance_32._off = true;

	this.timeline.addTween(cjs.Tween.get(this.instance_32).wait(15).to({_off:false},0).to({_off:true},32).wait(160));

	// bubble
	this.instance_33 = new lib.bubblewipebubble("synched",0,false);
	this.instance_33.parent = this;
	this.instance_33.setTransform(367.4,633.3,15.791,15.791);
	this.instance_33._off = true;

	this.timeline.addTween(cjs.Tween.get(this.instance_33).wait(6).to({_off:false},0).to({_off:true},41).wait(160));

	// bubble
	this.instance_34 = new lib.bubblewipebubble("synched",0,false);
	this.instance_34.parent = this;
	this.instance_34.setTransform(389.2,422.8,18.417,18.417);
	this.instance_34._off = true;

	this.timeline.addTween(cjs.Tween.get(this.instance_34).wait(5).to({_off:false},0).to({_off:true},42).wait(160));

	// bubble
	this.instance_35 = new lib.bubblewipebubble("synched",0,false);
	this.instance_35.parent = this;
	this.instance_35.setTransform(532.1,224.4,14.2,14.2);
	this.instance_35._off = true;

	this.timeline.addTween(cjs.Tween.get(this.instance_35).wait(8).to({_off:false},0).to({_off:true},39).wait(160));

	// bubble
	this.instance_36 = new lib.bubblewipebubble("synched",0,false);
	this.instance_36.parent = this;
	this.instance_36.setTransform(10.7,737.4,13.282,13.282);

	this.instance_37 = new lib.bubblewipebubble("synched",0,false);
	this.instance_37.parent = this;
	this.instance_37.setTransform(192.8,738.5,13.282,13.282);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[]}).to({state:[{t:this.instance_37},{t:this.instance_36}]},4).to({state:[]},43).wait(160));

	// bubble
	this.instance_38 = new lib.bubblewipebubble("synched",0,false);
	this.instance_38.parent = this;
	this.instance_38.setTransform(-52.4,618.2,7.386,7.386);

	this.instance_39 = new lib.bubblewipebubble("synched",0,false);
	this.instance_39.parent = this;
	this.instance_39.setTransform(61.7,592.3,11.622,11.622);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[]}).to({state:[{t:this.instance_39},{t:this.instance_38}]},9).to({state:[]},38).wait(160));

	// bubble
	this.instance_40 = new lib.bubblewipebubble("synched",0,false);
	this.instance_40.parent = this;
	this.instance_40.setTransform(196.7,604.7,7.615,7.615);

	this.instance_41 = new lib.bubblewipebubble("synched",0,false);
	this.instance_41.parent = this;
	this.instance_41.setTransform(210.6,492.7,13.282,13.282);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[]}).to({state:[{t:this.instance_41},{t:this.instance_40}]},3).to({state:[]},44).wait(160));

	// bubble
	this.instance_42 = new lib.bubblewipebubble("synched",0,false);
	this.instance_42.parent = this;
	this.instance_42.setTransform(136.1,400.8,7.111,7.111);

	this.instance_43 = new lib.bubblewipebubble("synched",0,false);
	this.instance_43.parent = this;
	this.instance_43.setTransform(224.3,333.8,13.282,13.282);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[]}).to({state:[{t:this.instance_43},{t:this.instance_42}]},4).to({state:[]},43).wait(160));

	// bubble
	this.instance_44 = new lib.bubblewipebubble("synched",0,false);
	this.instance_44.parent = this;
	this.instance_44.setTransform(-11.9,445.1,15.879,15.879);
	this.instance_44._off = true;

	this.timeline.addTween(cjs.Tween.get(this.instance_44).wait(2).to({_off:false},0).to({_off:true},45).wait(160));

	// bubble
	this.instance_45 = new lib.bubblewipebubble("synched",0,false);
	this.instance_45.parent = this;
	this.instance_45.setTransform(309.6,65.3,5.903,5.903);

	this.instance_46 = new lib.bubblewipebubble("synched",0,false);
	this.instance_46.parent = this;
	this.instance_46.setTransform(426.2,62,13.282,13.282);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[]}).to({state:[{t:this.instance_46},{t:this.instance_45}]},5).to({state:[]},42).wait(160));

	// bubble
	this.instance_47 = new lib.bubblewipebubble("synched",0,false);
	this.instance_47.parent = this;
	this.instance_47.setTransform(332.9,213,15.938,15.938);
	this.instance_47._off = true;

	this.timeline.addTween(cjs.Tween.get(this.instance_47).wait(1).to({_off:false},0).to({_off:true},46).wait(160));

	// bubble
	this.instance_48 = new lib.bubblewipebubble("synched",0,false);
	this.instance_48.parent = this;
	this.instance_48.setTransform(-26.9,278.1,8.323,8.323);

	this.instance_49 = new lib.bubblewipebubble("synched",0,false);
	this.instance_49.parent = this;
	this.instance_49.setTransform(86.8,270.4,13.282,13.282);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[]}).to({state:[{t:this.instance_49},{t:this.instance_48}]},3).to({state:[]},44).wait(160));

	// bubble
	this.instance_50 = new lib.bubblewipebubble("synched",0,false);
	this.instance_50.parent = this;
	this.instance_50.setTransform(192.3,211,8.001,8.001);

	this.instance_51 = new lib.bubblewipebubble("synched",0,false);
	this.instance_51.parent = this;
	this.instance_51.setTransform(168.7,62,16.292,16.292);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[]}).to({state:[{t:this.instance_51},{t:this.instance_50}]},8).to({state:[]},39).wait(160));

	// bubble
	this.instance_52 = new lib.bubblewipebubble("synched",0,false);
	this.instance_52.parent = this;
	this.instance_52.setTransform(-11.9,113.6,13.282,13.282);

	this.timeline.addTween(cjs.Tween.get(this.instance_52).to({_off:true},47).wait(160));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(628,476.8,48.3,49.3);
// library properties:
lib.properties = {
	width: 1320,
	height: 780,
	fps: 30,
	color: "#FFFFFF",
	opacity: 1.00,
	manifest: [
		{src:"../../../deploy/assets/images/TransitionBubble.png?1528314482635", id:"TransitionBubble"},
		{src:"../../../deploy/assets/images/TransitionBubblePop.png?1528314482635", id:"TransitionBubblePop"}
	],
	preloads: []
};




})(lib_Transition = lib_Transition||{}, images = images||{}, createjs = createjs||{}, ss = ss||{}, AdobeAn = AdobeAn||{});
var lib_Transition, images, createjs, ss, AdobeAn;